import Phaser from 'phaser';

/** 런 외형·전투 스탯 누적(허브 간 유지). 지옥 1층 전투 등에만 적용. */
export type PlayerBonuses = {
  maxHpFlat: number;
  speedMult: number;
  /** 1보다 작을수록 발사 간격이 짧아짐(더 빠른 연사). */
  fireRateMult: number;
};

export const DEFAULT_PLAYER_BONUSES: PlayerBonuses = {
  maxHpFlat: 0,
  speedMult: 1,
  fireRateMult: 1,
};

export const REGISTRY_PLAYER_BONUSES = 'player.bonuses';

export function getPlayerBonuses(registry: Phaser.Data.DataManager): PlayerBonuses {
  const raw = registry.get(REGISTRY_PLAYER_BONUSES);
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_PLAYER_BONUSES };
  const o = raw as Partial<PlayerBonuses>;
  return {
    maxHpFlat: typeof o.maxHpFlat === 'number' ? o.maxHpFlat : 0,
    speedMult: typeof o.speedMult === 'number' ? o.speedMult : 1,
    fireRateMult: typeof o.fireRateMult === 'number' ? o.fireRateMult : 1,
  };
}

export function setPlayerBonuses(registry: Phaser.Data.DataManager, b: PlayerBonuses): void {
  registry.set(REGISTRY_PLAYER_BONUSES, clampPlayerBonuses(b));
}

export function clampPlayerBonuses(b: PlayerBonuses): PlayerBonuses {
  return {
    maxHpFlat: Phaser.Math.Clamp(b.maxHpFlat, 0, 99),
    speedMult: Phaser.Math.Clamp(b.speedMult, 1, 2.8),
    fireRateMult: Phaser.Math.Clamp(b.fireRateMult, 0.38, 1),
  };
}
